import { PURCHASE_POINTS_BALANCE_SCOPE } from "@/features/purchasePoints/config/purchasePoints.config";
import { useEmployeeScopedQuery } from "@/features/purchasePoints/hooks/useEmployeeScopedQuery";
import { purchasePointsService } from "@/features/purchasePoints/services/purchasePoints.service";
import type { PurchasePointsBalance } from "@/features/purchasePoints/types/purchasePointsBalance.type";

export const usePurchasePointsBalance = (enabled = true) => {
  const {
    data, isLoading, isDisabled, isFetching, error, retry,
  } = useEmployeeScopedQuery<PurchasePointsBalance>({
    scope: PURCHASE_POINTS_BALANCE_SCOPE,
    queryFn: () => purchasePointsService.getBalance(),
    enabled,
  });

  return {
    balance: data ?? null,
    isLoading,
    isDisabled,
    isFetching,
    error,
    retry,
  };
};
